import {Component, Inject, OnInit} from '@angular/core';
import {FormGroup, FormControl, Validators, FormBuilder, FormGroupDirective, NgForm} from '@angular/forms';
import {DateAdapter, ErrorStateMatcher } from '@angular/material/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {MemberService} from 'src/app/services/member.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-gn1-work-dialog',
  templateUrl: './member-gn1-work-dialog.component.html',
  styleUrls: [ './member-gn1-work-dialog.component.scss' ]
})
export class MemberGN1WorkDialogComponent implements OnInit {

  public memberGN1: any = {}
  public memberSBCCV: any = {}
  public memberFormGN1: FormGroup;
  public memberFormSBCCV: FormGroup;
  public matcher = new FormErrorStateMatcher();

  public situations: any = []

  constructor (
    public matDialogRef: MatDialogRef<MemberGN1WorkDialogComponent>,
    private _memberService: MemberService,
    private _formBuilder: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.memberGN1 = this.data
    //console.log(JSON.stringify(this.memberGN1))
    this.getMemberSBCCV(this.memberGN1.cpf)

    this.situations.push({name: "Quite", value: "0"})
    this.situations.push({name: "Não-Quite", value: "1"})
    this.situations.push({name: "Isento", value: "2"})

  }

  ngOnInit () {
    this._adapter.setLocale('pt');
    this.memberFormGN1 = this.createFormGN1(this.memberGN1)
  }

  createFormGN1 (data: any) {
    let form: FormGroup = this._formBuilder.group({
      id: new FormControl(data.id),
      address: new FormControl(data.address),
      auxPhone1: new FormControl(data.auxPhone1),
      auxPhone2: new FormControl(data.auxPhone2),
      birthDate: new FormControl(data.birthDate || ''),
      category: new FormControl(data.category),
      cellPhone: new FormControl(data.cellPhone),
      city: new FormControl(data.city),
      clinicPhone: new FormControl(data.clinicPhone),
      complement: new FormControl(data.complement),
      concilState: new FormControl(data.concilState),
      cpf: new FormControl(data.cpf),
      crm: new FormControl(data.crm),
      district: new FormControl(data.district),
      email: new FormControl(data.email, [ Validators.email ]),
      email2: new FormControl(data.email2, [ Validators.email ]),
      excel_id: new FormControl(data.excel_id),
      exclude: new FormControl(data.exclude),
      faxPhone: new FormControl(data.faxPhone),
      filiationDate: new FormControl(data.filiationDate || ''),
      gender: new FormControl(data.gender),
      hospitalPhone: new FormControl(data.hospitalPhone),
      institute: new FormControl(data.institute),
      institute_begin: new FormControl(data.institute_begin || ''),
      institute_end: new FormControl(data.institute_end || ''),
      name: new FormControl(data.name),
      number: new FormControl(data.number),
      postalCode: new FormControl(data.postalCode),
      regional: new FormControl(data.regional),
      rg: new FormControl(data.rg),
      situation: new FormControl(data.situation),
      specialization: new FormControl(data.specialization),
      state: new FormControl(data.state),
      titleDate: new FormControl(data.titleDate || '')
    });
    return form
  }

  createFormSBCCV (data: any) {
    //console.log('SBCCV: ' + JSON.stringify(data))

    const dateFiliation: any = data.dateFiliation
    const dateBirth: any = data.dateBirth
    const dateTitle: any = data.dateTitle

    const resident_begin: any = data.resident_begin
    const resident_end: any = data.resident_end

    let form: FormGroup = this._formBuilder.group({
      id: new FormControl(data.id),
      address: new FormControl(data.address),
      aux1Phone: new FormControl(data.aux1Phone),
      aux2Phone: new FormControl(data.aux2Phone),
      category: new FormControl(data.subCategory.name),
      cellPhone: new FormControl(data.cellPhone),
      city: new FormControl(data.city),
      clinicPhone: new FormControl(data.clinicPhone),
      complement: new FormControl(data.complement),
      cpf: new FormControl(data.cpf),
      crm: new FormControl(data.crm),
      dateBirth: new FormControl(dateBirth ? dateBirth.toDate(): ''),
      dateFiliation: new FormControl(dateFiliation ? dateFiliation.toDate(): ''),
      dateTitle: new FormControl(dateTitle ? dateTitle.toDate(): ''),
      district: new FormControl(data.district),
      email: new FormControl(data.email, [ Validators.email ]),
      email2: new FormControl(data.email2, [ Validators.email ]),
      faxPhone: new FormControl(data.faxPhone),
      hospitalPhone: new FormControl(data.hospitalPhone),
      name: new FormControl(data.name),
      number: new FormControl(data.number),
      postalCode: new FormControl(data.postalCode),
      regional: new FormControl(data.regional),
      resident_institute: new FormControl(data.resident_institute),
      resident_begin: new FormControl(resident_begin ? resident_begin.toDate() : ''),
      resident_end: new FormControl(resident_end ? resident_end.toDate() : ''),
      rg: new FormControl(data.rg),
      sex: new FormControl(data.sex),
      situation: new FormControl(data.situation),
      state: new FormControl(data.state),


    })

    return form

  }

  getMemberSBCCV (cpf) {
    this._memberService.selectByDocNumber(cpf)
      .subscribe((result) => {

        this.memberSBCCV = result.docs[ 0 ].data()
        this.memberSBCCV.id = result.docs[ 0 ].id
        
        this.memberFormSBCCV = this.createFormSBCCV(this.memberSBCCV)

      })
  }

}
